import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Skeleton, Tabs, Tag } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import PurchaseOrderTableComponent from "../components/PurchaseOrderTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStoreLock } from "@fortawesome/pro-solid-svg-icons/faStoreLock";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import {
  faBox,
  faCube,
  faPallet,
  faRulerCombined,
} from "@fortawesome/pro-duotone-svg-icons";

const { TabPane } = Tabs;

const StockDetailPage = () => {
  const [isActive, setIsActive] = useState(true);
  return (
    <div className="w-full p-3">
      <div className="w-full">
        <div className="flex justify-end items-center mb-0">
          <div>
            <Tag
              className={
                isActive
                  ? "text-primary border-primary"
                  : "!text-red-500 border-red-500"
              }
            >
              {isActive ? "Active" : "Inactive"}
            </Tag>
          </div>
        </div>

        <div className="grid gap-3 md:grid-cols-3">
          <Card className="shadow-2xl p-0" size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon
                icon={faStoreLock}
                className="text-primary text-lg"
              />
              <p className="text-sm">SKU</p>
            </div>
            <p className="text-lg font-semibold ml-6 mt-0">SKU001</p>
          </Card>
          <Card className="shadow-2xl p-0 " size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-primary text-xl"
              />
              <p className="text-sm">Description</p>
            </div>
            <p className="text-lg font-semibold ml-6 mt-0">
              This is a sample description
            </p>
          </Card>
          <Card className="shadow-2xl p-0 " size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faBox} className="text-primary text-lg" />
              <p className="text-sm">QOH</p>
            </div>
            <p className="text-lg font-semibold ml-6 mt-0">4.00</p>
          </Card>
          <Card className="shadow-2xl p-0 " size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faCube} className="text-primary text-lg" />
              <p className="text-sm">Pack Size</p>
            </div>
            <p className="text-lg font-semibold ml-6 mt-0">20.00</p>
          </Card>
          <Card className="shadow-2xl p-0 " size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon
                icon={faPallet}
                className="text-primary text-lg"
              />
              <p className="text-sm">Pallet Quantity</p>
            </div>
            <p className="text-lg font-semibold ml-6 mt-0">0.25</p>
          </Card>
          <Card className="shadow-2xl p-0 " size="small">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon
                icon={faRulerCombined}
                className="text-primary text-lg"
              />
              <p className="text-sm">Dimension</p>
            </div>
            <div className="text-lg font-semibold">
              <div className="flex justify-around">
                <p className="m-0 p-0">Length: 25cm</p>
                <p className="m-0 p-0">Width: 25cm</p>
              </div>
              <div className="flex justify-around">
                <p className="m-0 p-0">Height: 25cm</p>
                <p className="m-0 p-0">Weight: 25cm</p>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Card className="!p-0 mt-4 shadow-2xl">
        <Tabs centered defaultActiveKey="1">
          <TabPane key="1" tab="Stock Transaction"></TabPane>

          <TabPane key="2" tab="Purchase Order">
            <PurchaseOrderTableComponent />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default StockDetailPage;
